import htm from "htm/mini";
import h from "hyperscript";
import { createTemplate, getShadowRoot } from "../utils";
const html = htm.bind(h);
const tagName = "crumbs-p";
const template = createTemplate(html `
	<style>
		:host {
			display: block;
		}

		p {
			font-size: 1rem;
		}

		::slotted(code) {
			padding: 5px;
			border-radius: 5px;
			display: inline-block;
			font-size: 0.9rem;
		}

		::slotted(code[block]) {
			display: block;
			margin: 1rem 0;
			white-space: pre;
		}

		@media screen and (min-width: 800px) {
			p {
				font-size: 1.4rem;
			}
		}
	</style>

	<p>
		<slot></slot>
	</p>
`);
class P extends HTMLElement {
    async connectedCallback() {
        this.attachShadow({ mode: "open" });
        const shadowRoot = getShadowRoot(this);
        const clonedTemplate = template.content.cloneNode(true);
        shadowRoot.appendChild(clonedTemplate);
    }
}
customElements.define(tagName, P);
